import { useState } from "react";
import { Send, Bot, Coins } from "lucide-react";
import Signals from "./Signals";
import ClaudeSignals from "./ClaudeSignals";
import GoldMTF from "./GoldMTF";
import { EngineControl } from "./EngineControl";

const TABS = [
  { key: "manual", label: "Manual Signals", icon: Send, Component: Signals },
  { key: "claude", label: "Claude Signals", icon: Bot, Component: ClaudeSignals },
  { key: "goldmtf", label: "GoldMTF", icon: Coins, Component: GoldMTF },
];

export default function SignalsHub() {
  const [tab, setTab] = useState("manual");
  const Active = TABS.find((t) => t.key === tab).Component;
  return (
    <div className="space-y-6">
      <EngineControl />
      <div className="flex items-center gap-2 border-b border-white/10 pb-1">
        {TABS.map((t) => (
          <button
            key={t.key}
            data-testid={`signals-tab-${t.key}`}
            onClick={() => setTab(t.key)}
            className={`flex items-center gap-2 px-4 py-2 text-sm rounded-t-lg transition-colors ${
              tab === t.key
                ? "text-[#00F0FF] border-b-2 border-[#00F0FF] -mb-px"
                : "text-gray-400 hover:text-white"
            }`}
          >
            <t.icon size={14} />
            {t.label}
          </button>
        ))}
      </div>
      <Active />
    </div>
  );
}
